import parse from 'html-react-parser';
import { useEffect, useId, useMemo, useRef } from 'react';
import { type IEmbedOnnetworkVideo } from '@/types/IEmbeds';
import styles from './index.module.scss';

export default function OnnVideo ({
  description,
  id,
  podcast,
  videoType,
}: IEmbedOnnetworkVideo) {
  const containerId = useId();
  const hasInitialized = useRef(false);
  const headingText = useMemo(() => podcast === 'true' ? 'Posłuchaj podcastu' : 'Zobacz wideo', [podcast]);

  useEffect(() => {
    /**
     * @INFO
     * Q: Why no cleanup of the script tag?
     * A: When the component genuinely unmounts, the container <div> is removed from the DOM which destroys the player regardless.
     */

    if (hasInitialized.current) {
      return;
    }

    hasInitialized.current = true;
    const script = document.createElement('script');
    script.src = `https://video.onnetwork.tv/embed.php?${videoType}=${id}&cId=${containerId}&ap=0&mploff=1`;
    script.defer = true;
    document.body.appendChild(script);
  }, [containerId, id, videoType]);

  return (
    <div className={styles['embeds-onn-video']}>
      <span className={styles['embeds-onn-video__title']}>{headingText}</span>
      {description ? <span className={styles['embeds-onn-video__description']}>{parse(description)}</span> : null}
      <div className={styles['embeds-onn-video__player']} id={containerId} />
    </div>
  );
}
